<section class="blue-bg">
    <button>IOS</button>
    <button>Android</button>
</section>
     
   